import React, { useRef, Fragment, useEffect } from 'react'
import { useDrag, useDrop } from 'react-dnd'
import MenuIcon from '@material-ui/icons/Menu';


const ItemTypes = {
  CARD: 'card',
  FOLDER:'folder'
}

export function onFolderDrop(item, folder_id, updateItem, updateFolder, folders){
  console.log(item, item.folder_id, folder_id, 'ITEM AND FOLDER DROP!!');
  if(folder_id=='back' || folder_id=='BACK'){
    if(folders!=undefined){
      let parent=(folders[item.folder_id]!=undefined)?folders[item.folder_id]:undefined;
      item.folder_id=(parent==undefined)?null:parent.folder_id;
    }
  }else{
    item.folder_id=Number(folder_id.replace('folder_', ''));
  }
  if(item.is_folder!=true){
    console.log('ITEM UP', item);
    updateItem(item.id, {folder_update:true, ...item});
  }else{
    updateFolder(item.id.replace('folder_', ''), {name:item.name, description:item.description, folder_id:item.folder_id});
    console.log('FOLDER UP', item);
  }
}


export const Folder = ({content, onDrop, id }) => {
  const [{ canDrop, isOver }, drop] = useDrop({
    accept: ItemTypes.CARD,
    drop: (item, monitor) => {
      if(onDrop!=undefined){onDrop(item, id);} // Perform the action when a card is dropped
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  const isActive = canDrop && isOver;
  let backgroundColor = 'transparent';
  if (isActive) {
    backgroundColor = '#e0e0e0'; // Highlight color when active
  } else if (canDrop) {
    backgroundColor = '#f9f9f9'; // Potential drop target color
  }

  return (
    <div ref={drop} style={{ backgroundColor }}>
      {content}
    </div>
  );
};


export const Card = ({ id, text, index, moveCard, is_folder, not_draggable, onDrop}) => {
  const ref = useRef(null)
  const [{ handlerId }, drop] = useDrop({
    accept: ItemTypes.CARD,
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      }
    },
    hover(item, monitor) {
      if(moveCard!=undefined){
      if (!ref.current) {
        return
      }
      const dragIndex = item.index
      const hoverIndex = index
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return
      }
      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect()
      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
      // Determine mouse position
      const clientOffset = monitor.getClientOffset()
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return
      }
      // Time to actually perform the action
      if(moveCard!=undefined){moveCard(dragIndex, hoverIndex);}
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex
    }},
    drop(item, monitor) {
      console.log('yo_yo_yo', item, index);
      // Call the onDrop function to handle any final actions after drop.
      // For instance, updating the state of the parent component
      if (onDrop) {
        onDrop(item.index, index);
      }
    },
  })
  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.CARD,
    item:{
      id:id,
      index:index,
      type:'card'
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  })


  const opacity = isDragging ? 0.3 : 1
  drag(drop(ref))
  if(is_folder==true && not_draggable==true){
    return(<Folder id={id} content={text} onDrop={onDrop}/>)
  }
  return (
    <div ref={ref} style={{ width:'100%', position:'relative', opacity }} data-handler-id={handlerId}>
      {(is_folder==true)?<Folder id={id} content={text} onDrop={onDrop}/>
      :text}
    </div>
  )
}
